// extracted by mini-css-extract-plugin
export default {"text":"style_text__XZQBV","smallGreyText":"style_smallGreyText__35Aj9"};